import { CardioOrResistance } from 'fitbeat.models';
import { bodyImagesDash, buildBodyImages, bodyImageGreyScale, noWorkoutGreyScale } from './BodyImageSets';

const getImageFromImageSet = (threeBodyGroups = [], gender = 'female', imageSet) => {
  if (gender === 'other') {
    gender = 'female';
  }

  const sortedThreeBodyGroups = threeBodyGroups.sort().join(' ');
  const bodyKey = `${gender} - ${sortedThreeBodyGroups}`;

  let bodyGroupImage = imageSet[bodyKey];

  if (bodyGroupImage) {
    return bodyGroupImage;
  }

  return buildBodyImages[`${gender} - `];
};

export const getBodyGroupImageForDash = (threeBodyGroups = [], cardioOrResistance, gender = 'female') => {
  return getImageFromImageSet(threeBodyGroups, gender, bodyImagesDash);
};

export const getGreyScaleBodyGroupImageDash = (threeBodyGroups = [], gender = 'female') => {
    return getImageFromImageSet(threeBodyGroups, gender, noWorkoutGreyScale);
  };